module.exports = "https://dashboard.cdn.gifty.nl/6224/images/logo-christmas.svg?b865672ae71a30db525e8c60cc81443b";